import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				background: theme.WHITE_100,
				boxShadow: "0px 3px 29px rgba(114, 136, 128, 0.15)",
				borderRadius: 6,
				padding: 10,
				marginTop: 16
			},
			level: {
				fontSize: 16,
				color: theme.palette.secondary.main,
				paddingBottom: 10,
				fontWeight: 500
			},
			title: {
				color: theme.palette.primary.contrastText,
				fontSize: 16,
				fontWeight: 500
			},
			text: {
				color: theme.palette.primary.contrastText,
				fontSize: 14,
				lineHeight: "16px",
				padding: "5px 0px"
			},
			discount: {
				background: theme.palette.grey[600],
				textAlign: "center",
				padding: 15,
				marginTop: 10,
				color: theme.palette.primary.contrastText,
				fontSize: 14,
				borderRadius: 6
			}
		}),
	{
		name: "LevelPromotion",
		index: 1
	}
);

export default useStyles;
